<template>
  <v-container fluid pa-3  background>
    <v-btn slot="activator" icon @click="backlist()" class="btn_show_filter">
      <v-icon :size="25">reply</v-icon>
    </v-btn>
    <v-layout row wrap pa-3 style="background-color:#fff; margin-top:5px; border-radius:5px;">
      <v-flex xs12>
        <v-form ref="form" v-model="form_valid">
          <v-layout row wrap>
            <v-flex md4 sm6 xs12 pa-1>
              <v-text-field
                v-model="datas.code"
                required
                :label="$t('doc_no')"
                append-icon="fas fa-plus-circle"
                hide-details
                @click:append="doNewGuid"
              />
            </v-flex>
            <v-flex md4 sm6 xs12 pa-1>
              <v-text-field
                :label="$t('date')"
                type="date"
                v-model="datas.date"
                required
                hide-details
              />
            </v-flex>
            <v-flex md4 sm6 xs12 pa-1>
              <v-text-field
                :label="$t('remark')"
                type="text"
                v-model="datas.remark"
                required
                hide-details
              />
            </v-flex>
            <v-flex md4 sm4 xs12 pa-1 v-if="branch_items.length > 0">
              <v-select
                required
                :items="branch_items"
                :label="$t('branch')"
                item-text="name"
                item-value="code"
                v-model="branch"
                hide-details
                @input="getProfileDepartmentList()"
              />
            </v-flex>
            <v-flex md4 sm4 xs12 pa-1 v-if="branch_items.length > 0">
              <v-select
                required
                :items="department_items"
                :label="$t('Department')"
                item-text="name"
                item-value="code"
                v-model="department"
                hide-details
                :disabled="department_items.length ==''"
                @input="getEmployeeList()"
              />
            </v-flex>

            <v-flex md4 sm6 xs12 pa-1>
               <v-autocomplete
                v-model="name"
                :items="Employee_list"
                item-text="name"
                item-value="name"
                :label="$t('employee_code')"
                :disabled="Employee_list.length ==''"
                append-icon="search"
                clearable
                hide-details
                required
                multiple
              >
                <template slot="selection" slot-scope="{ item, index }">
                  <span v-if="index === 0">{{ item.name }}</span>
                  <span
                    v-if="index === 1"
                    class="grey--text caption"
                  >(+{{ name.length - 1 }} others)</span>
                </template>
                <template slot="prepend-item">
                  <v-list-tile ripple @click="toggle" class="checkEmp">
                    <v-list-tile-action>
                      <v-checkbox
                        v-model="isChecked"
                        color="primary"
                        :indeterminate="selectSomeEmp"
                      ></v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Select All</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template slot="append-item">
                  <v-divider class="mb-2"></v-divider>
                </template>
               </v-autocomplete>
            </v-flex>
            <v-flex md2 sm6 xs12 style="margin-right:15px;" v-if="permission_edit == true || admin == 'true'">
              <v-btn color="warning" block class="white--text" @click="CreateDoc()">
                <p style=" font-size:12px;position: absolute;margin-top:15px;">{{$t('DownloadExample')}}</p>
              </v-btn>
            </v-flex>
            <v-flex md2 sm6 xs12 class="button-wrapper" v-if="permission_edit == true || admin == 'true'">
              <span class="label">{{$t('Upload')}}</span>
              <input
                :label="$t('ImportIncome')"
                type="file"
                id="file"
                ref="myFiles"
                class="upload-box"
                multiple
                @change="ImportExcel()"
                placeholder="Upload File"
              />
            </v-flex>
          </v-layout>
        </v-form>
        <v-flex md12 sm12 xs12>
          <v-layout row wrap v-if="ExpensedData.length > 0">
            <v-flex md12 sm12 xs12 v-for="(item, index) in ExpensedData" :key="index" @click="''">
              <v-card class="coco-box-shadow" v-if="!item.status">
                <v-layout align-center justify-center row fill-height wrap class="coco-list-layout">
                  <v-flex lg1 md1 sm2 xs3 text-xs-center>
                    <v-avatar :size="64">
                      <v-avatar
                        v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                        :size="64"
                        color="teal"
                      >
                        <span class="white--text headline">{{item.nick_name}}</span>
                      </v-avatar>

                      <Empimage
                        v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                        :json_data="item.emp_images"
                      />
                    </v-avatar>
                  </v-flex>
                  <v-flex lg9 md9 sm8 xs9>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <span
                          style="color:red;"
                        >{{isEmpty(item.emp_code)? item.emp_code : 'ไม่พบข้อมูล พนักงาน'}}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex lg2 md2 sm2 xs2>
                    <v-layout row wrap>
                      <v-flex md12 sm12 xs12 text-xs-center>
                        <v-layout row wrap>
                          <v-flex offset-lg5 offset-md3 lg3 md4 xs6>
                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                color="warning"
                                icon
                                flat
                                @click="EditItem(item,index)"
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <span>{{$t('edit')}}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex lg3 md4 xs6>
                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                color="error"
                                icon
                                flat
                                @click="deleteItem(item,index)"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                              <span>{{$t('delete')}}</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 offset-md1 offset-sm2 class="coco-list-divider">
                    <v-divider />
                  </v-flex>
                </v-layout>
              </v-card>
              <v-card class="coco-box-shadow coco-list-hover" v-if="item.status">
                <v-layout align-center justify-center row fill-height wrap class="coco-list-layout">
                  <v-flex lg1 md1 sm2 xs3 text-xs-center>
                    <v-avatar :size="64">
                      <v-avatar
                        v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                        :size="64"
                        color="teal"
                      >
                        <span class="white--text headline">{{item.nick_name}}</span>
                      </v-avatar>

                      <Empimage
                        v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                        :json_data="item.emp_images"
                      />
                    </v-avatar>
                  </v-flex>
                  <v-flex lg9 md9 sm8 xs9>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <span
                          class="coco-list-label-text"
                        >{{isEmpty(item.emp_code)? item.emp_code : 'emp_code'}}:</span>
                        <span>{{item.first_name}} {{item.last_name}}</span>
                        <span
                          v-html="(isEmpty(item.nick_name) ? ' (<span style=color:#166BFF;>'+item.nick_name+'</span>)' : '')"
                        />
                      </v-flex>
                      <v-flex xs12 class="hidden-xs-only">
                        <span class="coco-list-label-text hidden-sm-only">
                          {{$t('branch')}}:
                          <span>
                            {{isEmpty(item.branch)? item.branch
                            : ''}}
                          </span>
                        </span>
                        <span class="coco-list-label-text hidden-sm-only">
                          {{$t('Department')}}:
                          <span>
                            {{isEmpty(item.department_name) ?
                            item.department_name : ''}}
                          </span>
                        </span>
                        <span class="coco-list-label-text hidden-sm-only">
                          {{$t('Position')}}:
                          <span>
                            {{isEmpty(item.position) ?
                            item.position : ''}}
                          </span>
                        </span>
                        <span class="coco-list-label-icon">
                          <v-icon>access_time</v-icon>
                          <span>{{formatdate(item.effect_date)}}</span>
                        </span>
                        <span class="coco-list-label-icon">
                          <v-icon>monetization_on</v-icon>
                          <span
                            v-show="currencySymbols == '0'"
                          >{{symbolStyles + ' ' + formatNumber(item.amount, 2,true)}}</span>
                          <span
                            v-show="currencySymbols == '1'"
                          >{{formatNumber(item.amount, 2, true) + ' ' + symbolStyles}}</span>
                        </span>
                        <span class="coco-list-label-icon">
                          <v-icon>info</v-icon>
                          <span>{{isEmpty(item.name) ? item.name : '-'}}</span>
                        </span>
                      </v-flex>
                      <v-flex xs12 class="hidden-sm-and-up">
                        <span class="coco-list-label-icon">
                          <v-icon style="padding-left: 0px;">access_time</v-icon>
                          <span>{{formatdate(item.effect_date)}}</span>
                        </span>
                        <span class="coco-list-label-icon">
                          <v-icon>monetization_on</v-icon>
                          <span
                            v-show="currencySymbols == '0'"
                          >{{symbolStyles + ' ' + formatNumber(item.amount, 2, true)}}</span>
                          <span
                            v-show="currencySymbols == '1'"
                          >{{formatNumber(item.amount, 2, true) + ' ' + symbolStyles}}</span>
                        </span>
                      </v-flex>
                      <v-flex xs12 class="hidden-sm-and-up">
                        <span class="coco-list-label-icon">
                          <v-icon style="padding-left: 0px;">info</v-icon>
                          <span>{{isEmpty(item.name) ? item.name : '-'}}</span>
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  
                  <v-flex lg2 md2 sm2 xs12>
                    <v-layout row wrap>
                      <v-flex md12 sm12 xs12 text-xs-right>
                        <v-layout row wrap text-xs-right>
                          <v-flex offset-lg5 offset-md3 offset-xs4 lg3 md4 xs6>
                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                color="warning"
                                icon
                                flat
                                @click="EditItem(item,index)"
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <span>{{$t('edit')}}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex lg3 md4 xs2>
                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                color="error"
                                icon
                                flat
                                @click="deleteItem(item,index)"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                              <span>{{$t('delete')}}</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 offset-md1 offset-sm2 class="coco-list-divider">
                    <v-divider />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 text-xs-right>
              <v-btn color="#D84315" @click="back()">
                <v-icon class="mr-2" style="color:#ffffff">fas fa-arrow-left</v-icon>
                <span style="color:#ffffff">{{$t('back')}}</span>
              </v-btn>
              <v-btn color="#43A047" @click="onSave()">
                <v-icon class="mr-2" style="color:#ffffff">save</v-icon>
                <span style="color:#ffffff">{{$t('save')}}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <delete-dialog
          :json_data="delete_dialog_data"
          v-on:close-dialog="onCloseDeleteDialog"
          v-on:delete-item="onDelete"
        />
      </v-flex>
      <!-- FormEdit -->
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{$t('EditDocument')}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :label="$t('code')"
                      v-model="form_dialog.emp_code"
                      required
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('name')" v-model="form_dialog.first_name" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('amount')" v-model="form_dialog.amount" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('detail')" v-model="form_dialog.name" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :label="$t('effective_date')"
                      v-model="form_dialog.effect_date"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog = false">{{$t('close')}}</v-btn>
              <v-btn color="blue darken-1" flat @click="dialog = false;onUpdate()">{{$t('save')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- Form Create Doc -->
      <v-layout row justify-center>
        <v-dialog v-model="dialog_create" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{$t('CreateDocument')}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :label="$t('date')"
                      type="date"
                      v-model="form_dialog_create.date"
                      required
                      hide-details
                      :rules="form_rules.date"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :label="$t('detail')"
                      v-model="form_dialog_create.remark"
                      required
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog_create = false">Close</v-btn>
              <v-btn
                color="blue darken-1"
                flat
                @click="DownloadExampleExcel()"
              >Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import DocumentService from "@/services/DocumentService";
import SettingService from "@/services/SettingService";
import EmployeeService from "@/services/EmployeeService";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import UserService from "@/services/UserService";
import XLSX from "xlsx";
import Empimage from "../../components/getempimage.vue";
import moment from "moment";
import Utils from "@/utils/";
import { constants } from "crypto";
export default {
  data: () => ({
    dialog_create: false,
    branch: "",
    department: "",
    branch_items: [],
    department_items: [],
    Employee_list: [],
    Employee_items: [],
    isChecked: false,
    form_valid: false,
    dialog: false,
    form_dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
    delete_dialog_data: {
      status: false
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
    index: 0,
    form_dialog: {
      amount: "",
      name: "",
      emp_code: "",
      detailExpensed: "",
      effect_date: "",
      company_id: localStorage._company_guid,
    },
    form_dialog_create: {
      date: "",
      remark: ""
    },
     form_rules: {
      date: [v => !!v || "do not empty."]
    },
    head_example: [
      "รหัส",
      "ชื่อ",
      "จำนวน",
      "วันที่มีผล",
      "รายละเอียดค่าใช้จ่าย"
    ],
    detail_example: [],
    datas: {
      code: "",
      remark: "",
      date: new Date().toISOString().slice(0, 10),
      creator_code: localStorage._usercode,
      details: [],
      company_id: localStorage._company_guid,
    },
    results: [],
    ExpensedData: [],
    name: [],
    checkdata: true,
    permission_view:false,
    permission_edit:false,
    admin:false,
    empCode: localStorage._empcode,
    permission:[]
  }),

  components: {
    DeleteDialog,
    Empimage
  },
  computed: {
    ...mapState("app", [
      "showLoading",
      "formatDates",
      "symbolStyles",
      "currencySymbols"
    ]),
    ...mapState("filter", [
      "Employee_List"
    ]),
    //...mapState("permissionmenu", ["permission_List"]),
   
    selectAllEmp() {
      return this.name.length === this.Employee_list.length;
    },
    selectSomeEmp() {
      console.log(this.name.length);
      return this.name.length > 0 && !this.selectAllEmp;
    }
  },
  created: async function() {
    this.admin = localStorage._is_admin;
    await  UserService.getpermissionByusercode(this.empCode)
    .then(res=>{
      this.permission = res.data.permission;
      console.log(res)
    })
     .catch(err => {});
    await this.checkpermission("ImportFileExpensed");
    this.doNewGuid();
    this.getProfileBranchList();
    this.commitSetToolbar({ patternTool: "0" });
    this.getEmployee("refesh");
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    ...mapActions("app", ["commitSetToolbar"]),
    goto(path) {
      this.$router.push("/" + path);
    },
     checkpermission(page){
        let checkEdit = false
        let checkView = false
        if(this.permission.length != 0){
             this.permission.forEach(element => {
                 if(page == element.module_name){
                    checkEdit = element.edit;
                    checkView = element.reads;
                 }
             });
        }
        else{
            checkEdit = false;
            checkView = false;
        }
        this.permission_edit = checkEdit
        this.permission_view = checkView
    },
    formatdate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatdateDoc(date) {
      return moment(date).format("DDMMYYYY");
    },
    doNewGuid() {
      this.datas.code = Utils.newGuid(
        "EXP"+ localStorage._company_guid.substr(0, 6).toUpperCase() + this.formatdateDoc(this.datas.date)
      );
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
     getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then(res => {
          console.log(res);
          if(res.data.content.length >  0){
              this.branch_items = res.data.content;
              console.log( "eeee", this.branch_items )
          }
          else{
        
          console.log("ddddd")
          console.log(this.Employee_List)
         this.Employee_List.forEach(emp => {
           this.Employee_list.push(emp);
         });
         console.log(this.Employee_list)
          
          }
        })
        .catch(err => {
          console.log(err);
          console.log("ddddd")
           this.Employee_List.forEach(emp => {
           this.Employee_list.push(emp);
         });
          console.log(this.Employee_list)
        });
    },
    getProfileDepartment() {
      SettingService.getProfileDepartmentList()
        .then(res => {
          this.department_items = res.data.content;
          console.log(this.department_items);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      this.department = "";
      SettingService.getDepartmentByBranch(this.branch)
        .then(res => {
          this.department_items = res.data;
          console.log(this.department_items);
           this.getEmployeeList()
        })
        .catch(err => {
          console.log(err);
        });
    },
    getEmployeeList() {
      var position = "";
      var search = "";
      var page = "";
      EmployeeService.getEmployee(
        this.branch,
        this.department,
        position,
        search,
        page
      )
        .then(res => {
          this.Employee_items = res.data.content;
          this.Employee_list = [];
          this.Employee_items.forEach(emp => {
            if (emp.is_active) {
              this.Employee_list.push({
                code: emp.code,
                name: emp.code + " - " + emp.first_name + " " + emp.last_name
              });
            }
          });
          console.log(this.Employee_list);
        })
        .catch(err => {
          console.log(err);
        });
    },
    CreateDoc(){
       let v = this;
       if (v.name.length > 0) {
         this.dialog_create = true;
       }
       else{
         this.snack_model.status = true;
        this.snack_model.msg = "กรุณาเลือกรายชื่อพนักงานก่อน";
        this.snack_model.type = "error";
       }
    },
    DownloadExampleExcel() {
      let v = this;
        v.detail_example =[];
      if (v.name.length > 0) {
        if(v.form_dialog_create.date !=""){
          v.dialog_create = false;
        v.name.forEach(function(data) {
          let value = data.split(" - ");
          console.log(value[0] + " : " + value[1]);
          v.detail_example.push({
            รหัส: value[0],
            ชื่อ: value[1],
            วันที่มีผล: v.form_dialog_create.date,
            รายละเอียดค่าใช้จ่าย: v.form_dialog_create.remark,
            จำนวน: " "
          });
        });
        var config = { raw: true, type: "string" };
        var Example = XLSX.utils.json_to_sheet(
          v.detail_example,
          v.head_example,
          config
        );
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          Example,
          "เอกสารนำเข้ารายจ่าย"
        );
        XLSX.writeFile(wb, "เอกสารนำเข้ารายจ่าย" + ".xlsx");
      }
       else{
          this.snack_model.status = true;
        this.snack_model.msg = "กรุณากรอกวันที่มีผล";
        this.snack_model.type = "error";
       } 
      } else {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณาเลือกรายชื่อพนักงานก่อน";
        this.snack_model.type = "error";
      }
       this.form_dialog_create.date= "";
       this.form_dialog_create.remark= "";
    },
    ImportExcel() {
      let v = this;
      var config = { raw: true, type: "string" };
      var reader = new FileReader();
      reader.readAsArrayBuffer(this.$refs.myFiles.files[0]);
      reader.onload = function(e) {
        var data = new Uint8Array(reader.result);
        var wb = XLSX.read(data, { type: "array" });
        var firstSheetName = wb.SheetNames[0];
        var worksheet = wb.Sheets[firstSheetName];
        v.results = XLSX.utils.sheet_to_json(worksheet, config);
        //console.log(v.results);
        //console.log("5555");
          v.datas.details =[];
        for (let index = 0; index < v.results.length; index++) {
          if (
            v.results[index].รหัส != " " &&
            v.results[index].วันที่มีผล != " " &&
            v.results[index].จำนวน != " " &&
            v.results[index].รายละเอียดค่าใช้จ่าย != " " &&
            v.results[index].รายละเอียดค่าใช้จ่าย != undefined 
          ) {
            v.datas.details.push({
              emp_code: v.results[index].รหัส,
              effect_date: v.results[index].วันที่มีผล,
              amount: v.results[index].จำนวน,
              name: v.results[index].รายละเอียดค่าใช้จ่าย
            });
          } else if(v.results[index].รายละเอียดค่าใช้จ่าย == undefined ) {
            v.snack_model.status = true;
            v.snack_model.msg = "เอกสารไม่ถูกต้องกรุณาอัพโหลดเอกสารใหม่";
            v.snack_model.type = "error";
          }else {
            v.snack_model.status = true;
            v.snack_model.msg = "กรุณากรอกข้อมูลให้ครบถ้วน";
            v.snack_model.type = "error";
          }
        }
        console.log(v.datas);
        DocumentService.CheckDetail(v.datas.details)
          .then(res => {
            v.ExpensedData = res.data;
            console.log("checkdetail :", v.ExpensedData);
          })
          .catch(err => {
            this.snack_model.status = true;
            this.snack_model.msg = "ไม่พบข้อมูล";
            this.snack_model.type = "error";
          });
      };
      reader.onerror = function(e) {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณากรอกข้อมูลให้ครบถ้วน";
        this.snack_model.type = "error";
      };
    },

    onCloseDeleteDialog() {
      this.delete_dialog_data.status = false;
    },
    deleteItem(data, index) {
      this.delete_dialog_data.status = true;
      let message =
        "<p>" +
        this.$t("question.delete") +
        " " +
        data.emp_code +
        " " +
        data.first_name +
        data.last_name +
        "?</p>";
      this.delete_dialog_data.message = message;
      this.delete_dialog_data.index = index;
    },
    EditItem(data, index) {
      this.dialog = true;
      this.form_dialog = data;
      this.index = index;
      console.log("index: " + index);
    },
    onDelete() {
      console.log(this.delete_dialog_data.index);
      this.ExpensedData.splice(this.delete_dialog_data.index, 1);
      this.datas.details.splice(this.delete_dialog_data.index, 1);
      console.log("ondelete: importexpensed", this.datas);
    },
    timedRefresh(timeoutPeriod) {
      setTimeout("location.reload(true);", timeoutPeriod);
    },

    // findArrayObj(arr) {
    //   var arr_data = [];
    //   var arr_detail = [];
    //   arr.forEach(element => {
    //     if (element.resign.toString() == "false") {
    //       arr_data.push({ emp_code: element.emp_code });
    //     }
    //   });
    //   arr_data.forEach(element => {
    //     const data_expensed = this.datas.details.find(
    //       el => el.emp_code == element.emp_code
    //     );
    //     arr_detail.push(data_expensed);
    //   });

    //   return arr_detail;
    // },

    onSave() {
      let v = this;
       this.datas.details = this.ExpensedData;
       
      v.ExpensedData.forEach(data => {
        if (data.status == false) {
          v.checkdata = false;
          console.log("for: ", v.checkdata);
        }
      });
      this.datas.company_id = localStorage._company_guid;
      if (v.checkdata != false) {
        console.log(v.datas);
        DocumentService.createExpenses(v.datas)
          .then(res => {
            console.log(res);
            v.snack_model.status = true;
            v.snack_model.msg = v.$t("message.save");
            v.snack_model.type = "success";
            v.goto("ImportFile/ListExpensed");
          })
          .catch(err => {
            v.snack_model.status = true;
            v.snack_model.msg = err;
            v.snack_model.type = "error";
          });
      } else {
        //v.$refs.form.validate();
        v.snack_model.status = true;
        v.snack_model.msg = "กรุณาตรวจสอบข้อมูลและทำการอัพโหลดไฟล์ใหม่";
        v.snack_model.type = "error";
        window.onload = this.timedRefresh(1500);
      }
    },
    onUpdate() {
      let v = this;
      (v.datas.details[v.index].emp_code = v.form_dialog.emp_code),
        (v.datas.details[v.index].effect_date = v.form_dialog.effect_date),
        (v.datas.details[v.index].name = v.form_dialog.name),
        (v.datas.details[v.index].amount = v.form_dialog.amount),
        (this.snack_model.status = true);
      this.snack_model.msg = this.$t("message.update");
      this.snack_model.type = "success";
      console.log(v.datas);
    },
    back() {
      location.reload();
    },
    backlist(){
      this.goto("ImportFile/ListExpensed");
    },
    toggle() {
      this.$nextTick(() => {
        console.log(this.selectAllEmp);
        if (this.selectAllEmp) {
          this.name = [];
          this.isChecked = false;
          console.log("toggle ", this.isChecked);
        } else {
          this.isChecked = true;
          this.name = [];
          this.Employee_list.forEach(data => {
            this.name.push(data.name);
          });
        }
      });
    }
  }
};
</script>
<style>
.v-input--selection-controls {
  margin-top: 0;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}

#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
</style>